import React from 'react';
import moment from 'moment';
import { AppLink } from '../../../routing/containers';
import { Spinner, AlertMessage, QuickSearch, ListingPagination, ListingFilters } from 'hyperdb-utils';
import ListingFolders from './ListingFolders';
import ItemActions from './ItemActions';
import { displayLocalDate } from '../../../../helpers/date';

class ListingObjects extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    const hasSelectedItems = Object.keys(this.props.selectedItems || {}).filter(id => this.props.selectedItems[id]).length > 0;
    return (
      <div className="content-wrapper">
        <section className="content-header content-header-fixed">
          <div className="row form-inline">
            <div className="col-md-6">
              <div className="form-group">
                <ListingFolders
                  folders={ this.props.folders || [] }
                  nbMessagesByFolder={ this.props.nbMessagesByFolder || {} }
                  selectedFolder={ this.props.selectedFolder }
                  onChange={ this.props.onSelectFolder } />
              </div>
              &nbsp;
              <AppLink to={ `${this.props.mountedUrl}/new` }>
                <button type="button" className="btn btn-primary margin-bottom" title="Write new message">
                  <i className="fas fa-edit"></i>
                </button>
              </AppLink>
              &nbsp;
              <button type="button" className="btn btn-info margin-bottom" title="Refresh" onClick={ this.props.onRefresh }>
                <i className="fas fa-sync-alt"></i>
              </button>
            </div>
            {
              this.props.selectedFolder && (this.props.selectedFolder === 'inbox' || this.props.selectedFolder === 'notifications')
                ? <div className="col-md-3">
                    <ListingFilters
                      filters={ this.props.filters || [] }
                      selectedFilter={ this.props.selectedFilter }
                      onChange={ this.props.onSelectFilter } />
                  </div>
                : null
            }
            <div className="col-md-3">
              <QuickSearch
                searchKeyword={ this.props.search }
                initialized={ this.props.listingReady }
                onSearch={ this.props.onSearch } />
            </div>
          </div>
        </section>
        <section className="content content-fixed">
          {
            this.props.successMessage
              ? <AlertMessage
                  type="success"
                  onDismiss={ this.props.onDismissAlert }>
                    { this.props.successMessage }
                </AlertMessage>
              : null
          }
          {
            this.props.errorMessage
              ? <AlertMessage
                  type="error"
                  onDismiss={ this.props.onDismissAlert }>
                    { this.props.errorMessage }
                </AlertMessage>
              : null
          }
          <div className="box box-primary">
            <Spinner show={ this.props.loading } />
            <div className="box-body table-responsive no-padding">
              <div className="box-header">
                <ItemActions
                  { ...this.props }
                  title="Batch actions"
                  forBatch={ true }
                  disabled={ !hasSelectedItems }
                  folder={ this.props.selectedFolder }
                  filter={ this.props.selectedFilter }
                  onActionSuccessful={ this.props.onActionSuccessful } />
              </div>
              <table className="table table-hover table-striped table-bordered table-responsive">
                <thead>
                  <tr>
                    <th className="checkbox-batch-action">
                      <input type="checkbox" onClick={ this.props.onClickCheckboxAll } checked={ this.props.allCheckboxesChecked } />
                    </th>
                    <th>Message</th>
                    <th>Booking file</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {
                    (this.props.messages || []).map((message, i) => {
                      return (
                        <tr key={i}>
                          <td className="checkbox-batch-action">
                            <input type="checkbox" onClick={ this.props.onSelectItem.bind(null, message.id) } checked={ !!this.props.selectedItems[message.id] } />
                          </td>
                          <td>{ this.getValue(message, 'metadata') }</td>
                          <td>{ this.getValue(message, 'related_object_reference') }</td>
                          <td>
                            <ItemActions { ...this.props } message={ message } folder={ message.folder } onActionSuccessful={ this.props.onActionSuccessful } />
                          </td>
                        </tr>
                      );
                    })
                  }
                </tbody>
              </table>
              <ListingPagination
                page={ this.props.page }
                totalPages={ this.props.totalPages }
                onPageChange={ this.props.onPageChange } />
            </div>
          </div>
        </section>
      </div>
    );
  }

  getValue(message, attribute) {
    if (attribute === 'metadata') {
      const date = displayLocalDate(message.date, { timeFormat: 'HH:mm'});
      const person = (['sent', 'draft', 'deleted'].indexOf(this.props.selectedFolder) !== -1) ? message.recipient : message.sender;
      const url = message.folder === 'draft'
        ? `${this.props.mountedUrl}/${message.id}/edit`
        : `${this.props.mountedUrl}/${message.id}`;
      return (
        <AppLink to={ url } class="no-decoration">
          <div className={ ['inbox', 'notifications'].includes(message.folder) && !message.read ? 'message message-unread' : 'message' }>
            <span className="message-date">{ date } </span>
            <span className="message-from">{ person } </span>
            <span className="message-status">
              { !['draft', 'trash'].includes(message.folder) && message.forwarded ? <i className="fas fa-reply fa-rotate-180"/> : null }
              { message.answered ? <i className="fas fa-reply"/> : null }
              { ['inbox', 'notifications'].includes(message.folder) && (!message.pending ? <i className="fas fa-check"/> : (message.read ? <i className="far fa-envelope-open"/> : <i className="fas fa-envelope"/>)) }
            </span><br/>
            <span className="message-subject">{ message.subject }</span>
          </div>
        </AppLink>
      );
    }
    if (attribute === 'related_object_reference') { return message.related_object_reference; }
    if (attribute === 'read') { return message.read ? <i className="fas fa-check"/> : null; }
    if (attribute === 'forwarded') { return message.forwarded ? <i className="fas fa-check"/> : null; }
  }
}

export default ListingObjects;



// WEBPACK FOOTER //
// ./src/frontend/modules/email/message/components/Listing.jsx